import axios from "axios";
import env from "../env";

const jsonConfig = {
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 30000,
};

export const fetchSmartRoomHomeDetails = async (homeId) => {
  const res = await axios.get(
    `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/homeManagement/homes/${homeId}`,
    jsonConfig
  );
  return res.data;
};

export const fetchSensorHubDeviceStatus = async (deviceId) => {
  const res = await axios.get(
    `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/deviceManagement/devices/${deviceId}/mobile/status`,
    jsonConfig
  );
  return res.data;
};

export const fetchWeatherDetails = async (lat, lon) => {
  const baseUrl = (env.GET_DEVICEMANAGEMENT_API_URL() || "").replace(/\/$/, "");
  const res = await axios.post(
    `${baseUrl}/weatherdetails`,
    { lat, lon },
    {
      timeout: 30000,
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        Authorization: null,
        authorization: null,
        "x-auth-token": null,
        "X-Tenant-ID": null,
      },
    }
  );
  return res.data;
};
